/**
 * Import
 * - Libraries
 */
import { connect } from 'react-redux'
import { get } from 'lodash'
/**
 * Import
 * - Store
 */
import { RootState } from '../../../../../store'

/**
 * Import
 * - Actions
 */
import {
    setStep03,
    resetQuotes,
    setStep03Renewals,
    getRenewalVariation,
    getQuoteVariation
} from '../../../../../actions'

/**
 * Import
 * - Page component
 */
// import Step03 from '../../../Quote/Step03m/Step03m'
import Step03 from '../components/Step03m'

const mapStateToProps = (state: RootState, props: any) => {
    return {
        quote: state.quote,
        fullQuote: get(state.quote, 'fullRenewals.response.renewal', {}),
        totalExhibitsSumInsured:
            get(state.quote, 'fullRenewals.response.renewal.stockBusinessAssets.totalExhibitsSumInsured', 0),
        totalSpecifiedItem: get(state.quote, 'fullRenewals.response.renewal.stockBusinessAssets.totalSpecifiedItem', 0),
        exhibitsItems: get(state.quote, 'fullRenewals.response.renewal.stockBusinessAssets.specifiedItem', {}),
        incomingExhibitionLimit:
            get(state.quote, 'fullRenewals.response.renewal.stockBusinessAssets.incomingExhibitionLimit', 0),
        outgoingExhibitionLimit:
            get(state.quote, 'fullRenewals.response.renewal.stockBusinessAssets.outgoingExhibitionLimit', 0),
        editRenewals: true,
    }
}

export default connect(
    mapStateToProps,
    {
        setStep03: setStep03,
        setStep03Renewals: setStep03Renewals,
        resetQuotes: resetQuotes,
        getRenewalVariation,
        getQuoteVariation,
    }
)(Step03)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Renewals/EditRenewals/containers/Step03m.tsx